export default __webpack_public_path__ + "static/media/nanos_abenteuer_cover.0e11b58b.webp";